<div>
  <i class="fa fa-refresh" aria-hidden="true" (click)="searchService.searchStartSubject.next()" container="body"></i>
  <i class="fa sweep-icon" (click)="searchService.searchResetSubject.next()" container="body"></i>

  <app-search-tag-register *ngIf="showTagRegister" [searchParams]="searchParams"></app-search-tag-register>
  <app-notification-register *ngIf="showTagRegister" [searchParams]="searchParams" [searchService]="searchService">
  </app-notification-register>
</div>